import { useMutation, useQueryClient } from "react-query";

import { useAuth } from "../../sdk/hooks";
import { api } from "../../sdk/utils";

export const useProcessCustomizedOrders = (queryKey: string | string[]) => {
    const auth = useAuth();
    const queryClient = useQueryClient();

    return useMutation({
        mutationFn: async () => {
            if (!auth.token) {
                throw new Error(
                    "Cannot generate customization PDFs without authorization token.",
                );
            }

            return await api.orders.Order.processCustomizedOrders(auth.token);
        },
        onSuccess: () => {
            queryClient.invalidateQueries(queryKey);
        },
    });
};
